import { render, staticRenderFns } from "./RelatorioVencimentoListRoute.vue?vue&type=template&id=a8ceb61a"
import script from "./RelatorioVencimentoListRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioVencimentoListRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports